/**
 * Location redirect.
 *
 * Useful for non-Vue links, like redirects to K4.
 *
 * @param {string} href
 */
export function redirect(href) {
    // Prevent redirect loop in development environment.
    if (href !== (window.location.pathname + window.location.search)) {
        window.location.assign(href);
    }
}
